import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddQuestionComponent } from '../add-question/add-question.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertComponent } from '../alert/alert.component';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {
  questionsList: any[]=[];
  @Input() page: string = "";
  @Input() showEdit: boolean = true;
  @Output() nextStep = new EventEmitter<boolean>(false);
  itemId: number = 0;
  examenId: number = 0;
  clientId: number = 0;
  headQuestionForm!: FormGroup;
  isDisabledHead: boolean = false;
  isProduct: boolean = false;
  rol: number = 0;
  loader: boolean = false;

  constructor(
    private dialog: MatDialog,
    private activeroute: ActivatedRoute,
    private adminservice: AdminService,
    private router: Router,
    private storeservice: StoreService
  ) { }

  ngOnInit() {
    this.isProduct = this.router.url.includes('producto') ? true : false;
    this.rol = +this.storeservice.getProfile.rol_id;
    this.activeroute.queryParams.subscribe(params => {
      this.itemId = +params['id'];
      this.examenId = +params['examn'];
      this.clientId = +params['userId'];
      if (this.itemId > 0 && !this.isProduct && this.examenId > 0) {
        this.getQuestions();
      }else{
        this.getQuestionsProduct();
      }
    });
    this.formBuilder();
  }

  formBuilder(){
    this.headQuestionForm = new FormGroup({
      examnId: new FormControl(''),
      title: new FormControl('', Validators.required),
      instructions: new FormControl('', Validators.required),
      time: new FormControl('60')
    })
  }

  showDialogForm() {

    if (this.isProduct) {
      if (!this.itemId) {
        this.dialog.open(AlertComponent,{
          width: '776px',
          disableClose: true,
          data: {
            type: 'success',
            title: 'Mensaje del sistema',
            description: 'Para poder agregar preguntas a tu producto primero debes agregar el título y las instrucciones.',
            textButton: 'Entendido'
          }
        });
        return
      }
    }else{
      if (!this.examenId) {
        this.dialog.open(AlertComponent,{
          width: '776px',
          disableClose: true,
          data: {
            type: 'success',
            title: 'Mensaje del sistema',
            description: 'Para poder agregar preguntas a tu examen primero debes agregar el título y las instrucciones.',
            textButton: 'Entendido'
          }
        });
        return
      }
    }

    let dialogRef = this.dialog.open(AddQuestionComponent,{
      width: '776px',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(
      (response)=>{
        if (response) {
          this.questionsList.push(
            {
              pregunta_id : 0,
              producto_id : this.examenId,
              tipo_pregunta_id : response,
              pregunta: '',
              opciones: response != 1 ? [
                {
                  value: ''
                }
              ] : [],
              disabled: false
            }
          )
        }
      }
    );
  }

  saveQuestion(question:any) {
    if (question.pregunta == "") {
      return
    }

    this.loader = true;
    if (this.isProduct) {
      const request = {
        pregunta_id: question.pregunta_id,
        producto_id: this.itemId,
        tipo_pregunta_id: question.tipo_pregunta_id,
        pregunta: question.pregunta,
        opciones: question.opciones.map((element:any)=>(element.value))
      }
      this.adminservice.saveQuestionProduct(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            question.pregunta_id = response.result;
            question.disabled = true;
          }
        }
      );
    }else{
      const request = {
        pregunta_id: question.pregunta_id,
        examen_id: this.examenId,
        tipo_pregunta_id: question.tipo_pregunta_id,
        pregunta: question.pregunta,
        opciones: question.opciones.map((element:any)=>(element.value))
      }
      this.adminservice.saveQuestion(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            question.pregunta_id = response.result;
            question.disabled = true;
          }
        }
      );
    }

  }

  addOption(question:any) {
    question.opciones.push({ value: '' })
  }

  getQuestions(){
    this.loader = true;
    this.adminservice.getQuestions(this.itemId).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          const questionHead = response.result.find((element:any)=> +element.id == this.examenId);
          const data = {
            examnId: this.examenId,
            title: questionHead?.titulo,
            instructions: questionHead?.descripcion,
            time: '60'
          }
          this.headQuestionForm.patchValue(data);
          this.isDisabledHead = questionHead ? true : false;

          //set questions
          const dataQuestions = questionHead.preguntas;
          dataQuestions.forEach((element:any)=>{
            this.questionsList.push(
              {
                pregunta_id : element.id,
                producto_id : this.examenId,
                tipo_pregunta_id : element.tipo_pregunta_id,
                pregunta: element.pregunta,
                opciones: element.alternativas.map((element:any)=>({value: element.alternativa, id: element.id, checked: false})),
                disabled: true
              }
            );
          })
        }
      }
    );
  }

  getQuestionsProduct(){
    this.loader = true;
    this.adminservice.getProducts(this.itemId).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          const questionHead = response.result.find((element:any)=> +element.id == this.itemId)
          const data = {
            examnId: this.examenId,
            title: questionHead?.titulo,
            instructions: questionHead?.descripcion,
            time: ''
          }
          this.headQuestionForm.patchValue(data);
          this.isDisabledHead = questionHead ? true : false;

          //set questions
          const dataQuestions = questionHead?.preguntas;
          dataQuestions?.forEach((element:any)=>{
            this.questionsList.push(
              {
                pregunta_id : element.id,
                producto_id : this.examenId,
                tipo_pregunta_id : element.tipo_pregunta_id,
                pregunta: element.pregunta,
                opciones: element.alternativas.map((element:any)=>({value: element.alternativa, id: element.id, checked: false})),
                disabled: true,
                answer: ''
              }
            );
          })
        }
      }
    );
  }

  saveHeadQuestion(){
    if (!this.headQuestionForm.valid) {
      return
    }

    if (this.isProduct) {
      const request = {
        producto_id: this.itemId,
        titulo: this.headQuestionForm.value.title,
        descripcion: this.headQuestionForm.value.instructions
      }
      this.loader = true;
      this.adminservice.saveProduct(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.isDisabledHead = true;
            this.itemId = response.result;
            const data = {
              type: 'success',
              title: 'Registro exitoso',
              description: 'Los datos generales del producto se ha guardado exitosamente.',
              textButton: 'Entendido'
            }
            this.showDialog(data);
          }
        }
      );
    }else{
      const request = {
        examen_id: this.examenId,
        curso_id: this.itemId,
        titulo: this.headQuestionForm.value.title,
        descripcion: this.headQuestionForm.value.instructions,
        duracion: this.headQuestionForm.value.time
      }
      this.loader = true;
      this.adminservice.saveHeadQuestion(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.isDisabledHead = true;
            this.examenId = response.result;
            const data = {
              type: 'success',
              title: 'Registro exitoso',
              description: 'Los datos generales del exámen se ha guardado exitosamente.',
              textButton: 'Entendido'
            }
            this.showDialog(data);
          }
        }
      );
    }
  }

  deleteQuestion(question:any){
    const request = {
      pregunta_id: question.pregunta_id
    }
    this.loader = true;
    if (this.isProduct) {
      this.adminservice.deleteQuestionProduct(request).subscribe(
        (response)=>{
          this.loader = false;
          if(response.rtn){
            let index = this.questionsList.indexOf(question,0);
            this.questionsList.splice(index,1);
            this.questionsList = [...this.questionsList];
            const data = {
              type: 'success',
              title: 'Operación exitosa',
              description: 'La pregunta del exámen se ha eliminado correctamente.',
              textButton: 'Entendido'
            }
            this.showDialog(data);
          }
        }
      );
    }else{
      this.adminservice.deleteQuestion(request).subscribe(
        (response)=>{
          this.loader = false;
          if(response.rtn){
            let index = this.questionsList.indexOf(question,0);
            this.questionsList.splice(index,1);
            this.questionsList = [...this.questionsList];
            const data = {
              type: 'success',
              title: 'Operación exitosa',
              description: 'La pregunta del exámen se ha eliminado correctamente.',
              textButton: 'Entendido'
            }
            this.showDialog(data);
          }
        }
      );
    }
  }

  goTo(){
    this.router.navigateByUrl(this.router.url.includes('entrenamiento') ? `entrenamiento/detalle?id=${this.itemId}`: 
    this.router.url.includes('entrenamiento/examen') ? `entrenamiento/curso?id=${this.itemId}` : 'productos')
  }

  showDialog(data:any){
    this.dialog.open(AlertComponent,{
      width: '776px',
      disableClose: true,
      data: {
        type: data.type,
        title: data.title,
        description: data.description,
        textButton: data.textButton
      }
    });
  }

  dialogDelete(){
    let dialogRef = this.dialog.open(AlertComponent,{
      width: '776px',
      disableClose: true,
      data: {
        type: 'alert',
        title: '¿Deseas eliminar este producto?',
        description: 'Recuerda que si decides hacerlo todos los datos que estén dentro de el se eliminarán.',
        textButton: 'Eliminar'
      }
    });

    dialogRef.afterClosed().subscribe(
      (response)=>{
        if (response) {
          this.deleteProduct();
        }
      }
    );
  }
  
  deleteProduct(){
    const request = {
      producto_id: this.itemId
    }

    this.adminservice.deleteProduct(request).subscribe(
      (response)=>{
        if (response.rtn) {
          const data = {
            type: 'success',
            title: 'Operación exitosa',
            description: 'La pregunta del exámen se ha eliminado correctamente.',
            textButton: 'Entendido'
          }
          this.showDialog(data);
          this.router.navigateByUrl('productos')
        }
      }
    );
  }

  registerQuestions(){
    let checkboxsList:any[]=[];
    this.questionsList.forEach((element:any)=>{
      if (element.tipo_pregunta_id == 4) {
        element.opciones.forEach((item:any)=>{
          if (item.checked) {
            checkboxsList.push(item.id.toString())
          }
        })
        element.answer = checkboxsList;
      }
    })

    this.loader = true;
    if (this.isProduct) {
      
      const request = {
        cliente_id: this.clientId ,
        producto_id: this.itemId,
        formulario: this.questionsList.map((element)=>({pregunta_id: element.pregunta_id, respuesta: element.answer}))
      }
      this.adminservice.registerQuestionProduct(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.nextStep.emit(true);
          }
        }
      );

    }else{

      const request = {
        examen_id: this.examenId,
        formulario: this.questionsList.map((element)=>({pregunta_id: element.pregunta_id, respuesta: element.answer}))
      }

      this.adminservice.registerQuestionExamen(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            const data = {
              type: 'success',
              title: 'Registro exitoso',
              description: 'Las respuestas del examen se ha guardado exitosamente.',
              textButton: 'Entendido'
            }
            this.showDialog(data);
            this.router.navigateByUrl(`entrenamiento/curso?id=${this.itemId}`)
          }
        }
      );

    }
  }

}
